import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import Navbar from './core/components/Navbar';
import Admin from './pages/Admin';
import Catalog from './pages/Catalog';
import Landing from './pages/Landing';
import ProductDetails from './pages/Catalog/components/ProductDetails';
import Home from './pages/Home';
import Auth from './pages/Auth';

const Routes = () => (
    <BrowserRouter>
        <Navbar/>
        <RouterRoutes>
            <Route path="/" element={<Home/>} />
            <Route path="/products" element={<Catalog/>} />
            <Route path="/landing" element={<Landing/>} />
            <Route path="/products/:productId" element={<ProductDetails/>} />
            <Route path="/auth/*" element={<Auth/>} />
            <Route path="/admin/*" element={<Admin/>} />
            <Route path="/auth" element={<Navigate to="/auth/login" replace />} />
            <Route path="/admin" element={<Navigate to="/admin/products" replace />} />
        </RouterRoutes>
    </BrowserRouter>
);

export default Routes;

